<div class="social-login-page" *letVar="loginType$ | async">
    <clare-spinner [text]="spinnerText" position="absolute"></clare-spinner>
</div>
